import React, { ReactNode } from 'react';

const Container: React.FC<{ children: ReactNode }> = ({ children }) => (
  <div className="container mx-auto max-w-6xl p-2 bg-white rounded-2xl">
    {children}
  </div>
);

export default Container;
